// @ts-strict-ignore
import React, {useContext} from 'react';
import {clsx} from 'clsx';
import {Typography} from 'onboarding-components';

import {SvgIconReact} from 'common/components/svg-icon';
import {useTranslation} from 'common/i18n/hooks';

import styles from '../index.module.styl';
import {TrackingEvent, TrackingProperty, trackOnboardingEvent} from '../tracking';
import {SetupGuideContext, Step} from '../types';
import {ProjectToken} from './project-token';

const StepIndicatorV2 = ({isCompleted, moniker, children, step: targetStep}) => {
  const {step, setStep} = useContext(SetupGuideContext);

  return (
    <div
      className={clsx({[styles.completed]: isCompleted}, styles.indicator, {[styles.current]: step === targetStep})}
      onClick={() => {
        setStep(targetStep);
        trackOnboardingEvent(TrackingEvent.StepClick, {[TrackingProperty.StepName]: targetStep});
      }}
    >
      {isCompleted ? (
        <div className={clsx(styles.moniker, styles.completed, {[styles.current]: step === targetStep})}>
          <SvgIconReact icon='checkmark' />
        </div>
      ) : (
        <div className={clsx(styles.moniker, {[styles.current]: step === targetStep})}>
          <Typography variant='eyebrowSm' weight='bold' style={{letterSpacing: 0, lineHeight: `100%`}}>
            {moniker}
          </Typography>
        </div>
      )}
      <Typography variant='bodySm' weight='bold'>
        {children}
      </Typography>
    </div>
  );
};

export const SideNavPhase2 = () => {
  const {completed} = useContext(SetupGuideContext);
  const {t} = useTranslation();

  return (
    <div className={styles.nav}>
      <div>
        <Typography variant='headingMd' style={{margin: 0}}>
          {t(`onboarding.sidenav.setup-guide`)}
        </Typography>
        <div className={styles.indicatorGroup}>
          {/* Replace with components */}
          <StepIndicatorV2 isCompleted={completed[Step.GetStarted]} moniker={1} step={Step.GetStarted}>
            {t(`onboarding.sidenav.get-started`)}
          </StepIndicatorV2>
          <StepIndicatorV2 isCompleted={completed[Step.Connect]} moniker={2} step={Step.Connect}>
            {t(`onboarding.sidenav.connect-data`)}
          </StepIndicatorV2>
          <StepIndicatorV2 isCompleted={completed[Step.Verify]} moniker={3} step={Step.Verify}>
            {t(`onboarding.sidenav.verify-connection`)}
          </StepIndicatorV2>
        </div>
      </div>
      <div className={styles.footerButton}>
        <ProjectToken />
      </div>
    </div>
  );
};
